module.exports = __webpack_public_path__ + "static/the-dhammapada-d054fade77aa75d94bbda2749518cd6f.jpg";